module.exports = [
    {
        locale: "fr",
        label: "French",
        routes: {
            "/": "/",
            "/teddy": "/teddy",
            "/violetta": "/violetta",
            "/julie": "/julie",
            "/about": "/a-propos",
            "/pricing": "/tarifs",
            "/paul":"/paul",
            "/login": "/connexion",
            "/community": "/community",
            "/404": "/404",
            "/404.html": "/404.html",
            "/blog": "/blog",
            "/price":"/tarifs",
            "/security-policy": "/politique-securite",
            "/gdpr": "/rgpd",
            "/legal-notice": "/legal-notice",
            "/conditions": "/cgu",
            "/dev-404-page": "/dev-404-page",
            "/404":"/404",
            "/cookie-policy": "/cookie-policy"
        }
    },
    {
        default: true,
        locale: "en",
        label: "English",
        routes: {
            "/": "/",
            "/teddy": "/teddy",
            "/violetta": "/violetta",
            "/julie": "/julie",
            "/about": "/about",
            "/pricing": "/pricing",
            "/paul":"/paul",
            "/login": "/login",
            "/community": "/community",
            "/404": "/404",
            "/404.html": "/404.html",
            "/blog": "/blog",
            "/price":"/pricing",
            "/security-policy": "/security-policy",
            "/gdpr": "/gdpr",
            "/legal-notice": "/legal-notice",
            "/conditions": "/conditions",
            "/dev-404-page": "/dev-404-page",
            "/404":"/404",
            "/cookie-policy": "/cookie-policy"
        }
    }
];
